import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Marcelo T.',
  location: 'Córdoba',
  image: 'https://cdn.magicpatterns.com/uploads/ubLA7JRcrsiW9xo6HPFCQa/ChatGPT_Image_4_may_2026,_03_57_20_p.m..webp',
  text: 'La verdad que esta formacion me dio todas las herramientas que necesitaba. En dos semanas ya estaba laburando con los primeros autos y recuperé lo que invertí.'
}, {
  name: 'Braian L.',
  location: 'Tucumán',
  image: 'https://cdn.magicpatterns.com/uploads/mbLU2mDX2CXgCbLpeBEios/ChatGPT_Image_4_may_2026,_03_45_36_p.m..webp',
  text: 'Yo no sabía nada de detailing y con esta guía arranqué de cero. Hoy ya tengo mis clientes fijos y laburo desde el fondo de mi casa aspirando a poner mi taller'
}, {
  name: 'Tomás R.',
  location: 'Buenos Aires',
  image: 'https://cdn.magicpatterns.com/uploads/cP9VcPbyCBKJRszE3NEteq/ChatGPT_Image_4_may_2026,_12_44_07_p.m..webp',
  text: 'con la formación entendí qué productos usar y cómo cobrar. Está todo explicado paso a paso y de manera simple para entender todo. Me sirvió un montón para empezar con este nuevo proyecto.'
}];
function StarRating() {
  return <div className="flex items-center gap-0.5" data-id="element-193">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-brand-yellow text-brand-yellow" data-id="element-194" />)}
    </div>;
}
export function PhotoTestimonialsSection() {
  return <section className="py-16 px-4 bg-[#0a0a0a]" data-id="element-195">
      <div className="max-w-3xl mx-auto" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-197">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-yellow/70 font-bold mb-3" data-id="element-198">
            De cero a sus primeros resultados
          </p>
          <h2 className="text-2xl md:text-3xl font-black text-white" data-id="element-199">
            Ellos ya <span className="text-brand-yellow" data-id="element-200">lo lograron</span>
          </h2>
        </motion.div>

        <div className="space-y-5" data-id="element-201">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative bg-[#111] border border-gray-800/80 rounded-2xl p-5 md:p-6 hover:border-brand-yellow/20 transition-colors duration-300" data-id="element-202">
              {/* Header: Photo + Info */}
              <div className="flex gap-4 md:gap-5 items-center mb-4" data-id="element-203">
                {/* Square Photo */}
                <div className="flex-shrink-0" data-id="element-204">
                  <div className="w-[162px] h-[162px] md:w-[189px] md:h-[189px] rounded-xl overflow-hidden border-2 border-brand-yellow/30 shadow-[0_0_15px_rgba(245,197,24,0.1)]" data-id="element-205">
                    <img src={t.image} alt={t.name} width={189} height={189} loading="lazy" className="w-full h-full object-cover" data-id="element-206" />
                  </div>
                </div>

                {/* Name, Location & Stars */}
                <div className="flex-1 min-w-0" data-id="element-207">
                  <p className="text-white font-bold text-base md:text-lg leading-tight" data-id="element-208">
                    {t.name}
                  </p>
                  <p className="text-gray-500 text-xs font-medium mb-1.5" data-id="element-209">
                    {t.location}
                  </p>
                  <StarRating data-id="element-210" />
                </div>
              </div>

              {/* Quote */}
              <p className="text-gray-300 text-sm md:text-[15px] leading-relaxed pl-1" data-id="element-211">
                "{t.text}"
              </p>

              {/* Subtle quote accent */}
              <Quote className="absolute top-4 right-4 w-5 h-5 text-brand-yellow/10" data-id="element-212" />
            </motion.div>)}
        </div>

        {/* Verified badge */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-2 mt-6" data-id="element-213">
          <div className="w-1.5 h-1.5 bg-green-500 rounded-full" data-id="element-214" />
          <p className="text-xs text-gray-500 font-medium uppercase tracking-wider" data-id="element-215">
            Compradores verificados
          </p>
        </motion.div>
      </div>
    </section>;
}